import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-unavailable-dialog',
  templateUrl: './document-unavailable-dialog.component.html',
  styleUrls: ['./document-unavailable-dialog.component.scss']
})
export class DocumentUnavailableDialogComponent {
  @Input() documentType?: string;

  get documentName(): string {
    switch (this.documentType) {
      case 'CD':
        return 'Construction Documents';
      case 'SD':
        return 'Shop Drawings';
      default:
        return 'Document';
    }
  }

  constructor(public activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.close();
  }
}
